import type { Hearing } from "@/lib/public-hearings/types";

// City-of-Calgary source documents (cover-report PDF, DMAP property
// lookups, meeting record) as verified source chips. Reuses
// `.cs-source-chip[data-verified="yes"]` so the leading signal-dot
// reads the same as everywhere else on the site.
export function CityDocumentsSection({ hearing: h }: { hearing: Hearing }) {
  const hasAny =
    h.coverReportUrl != null ||
    h.dmapUrls.length > 0 ||
    h.meeting.url != null;

  if (!hasAny) return null;

  return (
    <section className="ph-detail-panel" aria-label="City documents">
      <h2 className="ph-detail-panel-l">
        <span>City documents</span>
        <span className="count">primary sources</span>
      </h2>
      <ul className="list-none p-0 m-0 flex flex-wrap gap-2">
        {h.coverReportUrl && (
          <li>
            <a
              href={h.coverReportUrl}
              target="_blank"
              rel="noreferrer"
              className="cs-source-chip"
              data-verified="yes"
              title="Cover report PDF — City of Calgary, eSCRIBE"
            >
              <span>City of Calgary</span>
              <span aria-hidden className="text-ink-3">·</span>
              <span>cover report (PDF)</span>
            </a>
          </li>
        )}
        {h.dmapUrls.map((url, i) => (
          <li key={url}>
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className="cs-source-chip"
              data-verified="yes"
              title="Open in DMAP — City of Calgary"
            >
              <span>City of Calgary</span>
              <span aria-hidden className="text-ink-3">·</span>
              <span>
                DMAP{h.dmapUrls.length > 1 ? ` ${i + 1}` : ""}
              </span>
            </a>
          </li>
        ))}
        {h.meeting.url && (
          <li>
            <a
              href={h.meeting.url}
              target="_blank"
              rel="noreferrer"
              className="cs-source-chip"
              data-verified="yes"
              title="View the meeting record — City of Calgary, eSCRIBE"
            >
              <span>City of Calgary</span>
              <span aria-hidden className="text-ink-3">·</span>
              <span>meeting record</span>
            </a>
          </li>
        )}
      </ul>
    </section>
  );
}
